/**
* @name: AppSpaceSelItem
* @author: weiyong
* @date: 2022-10-02 09:13
* @description：AppSpaceSelItem
* @update: 2022-10-02 09:13
*/
<template>
  <div class="app-space-sel-item"
       v-if="getAppSpaceList&&getAppSpaceList.length>0" :class="prefixCls" style="font-size: 18px;">
    <AppstoreOutlined/>
    <span class="label">{{ getAppCurSpaceItem&&getAppCurSpaceItem.name }}</span>

    <div class="space-sel-panel" :style="appPanelSty">
      <div class="space-item" @click="selSpaceItemFun(spaceItem)" :key="spaceItem.id" v-for="(spaceItem,index) in getAppSpaceList"
           :class="getAppCurSpaceItem&&spaceItem.id===getAppCurSpaceItem.id?'active':''">
        <div class="space-item-icon">
          <AppstoreOutlined/>
        </div>
        <div class="space-item-label">{{ spaceItem.name }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "AppSpaceSelItem"
}
</script>

<script lang="ts" setup>
import {useSpaceHook} from '@/hooks/layouts/useSpaceHook';
import {usePcSpaceStore} from "@/store/pcSpaceStore";
import { AppstoreOutlined } from '@ant-design/icons-vue';
import {useDesign} from "@/hooks/web/useDesign";
import {nextTick, reactive, ref, toRefs, unref, watch} from "vue";
import {useRouter} from "vue-router";
import {PageEnum} from "@/enums/pageEnum";
const {prefixCls} = useDesign('AppSpaceSelItem');
const {
  appPanelSty,
  getAppSpaceList,
  getAppCurSpaceItem,
  selAppSpaceItem,
  clearCurSpaceItem,
} = useSpaceHook();

const props=defineProps({
  showType:{
    type:String,
    default:'main'
  },
  appId:{
    type:String,
    default:''
  },
  spaceType:{
    type:String,
    default:'main'
  }
});
const {spaceType}=toRefs(props);

const router = useRouter();
const selSpaceItemFun=(itemObj)=>{
  router.push({path: '/dashboard/appMainPage'});
  nextTick(()=>{
    selAppSpaceItem(itemObj);
  })
}

const { currentRoute } = useRouter();
watch(
  [() => currentRoute.value.path],
  () => {
    const route = unref(currentRoute);
    if(PageEnum.BASE_HOME_URL===currentRoute.value.path||"/dashboard/appMainPage"===currentRoute.value.path){
      return
    }else{
      clearCurSpaceItem();
    }
  }
);

</script>

<style type="text/css" lang="less">
@header-app:50px;
@sub-header-app: 50px;
@prefix-cls: ~'@{namespace}-AppSpaceSelItem';
/**
  APP模式下
 */
.@{prefix-cls} {
  &.app-space-sel-item:hover {
    color:#333;
    background-color: @header-light-bg-hover-color;
    .space-sel-panel{
      color:#333;
    }
  }
}

/**
  传统模式下
 */
.@{namespace}-layout-multiple-header--dark{
  .ant-layout-header{
    .@{prefix-cls} {
      height:  48px;
      .space-sel-panel{
        top: calc(38px - 1px);
      }
      .space-sel-panel{
        color: #333;
      }
      &:hover{
        background-color:@header-dark-bg-hover-color;
      }
    }
  }
}

/**
  传统模式下
 */
.@{namespace}-layout-multiple-header--light{
  .ant-layout-header{
    .@{prefix-cls} {
      height:  48px;
      color: #333;
      .space-sel-panel{
        top: calc(48px - 1px);
      }
      .space-sel-panel{
        color: #333;
      }
      &:hover{
        background-color:@header-light-bg-hover-color;
      }
    }
  }
}

.@{prefix-cls} {

  &.app-space-sel-item{
    font-size: 18px;
    display: flex;
    height:  @header-app;
    padding: 1px 10px 0;
    cursor: pointer;
    align-items: center;
    position: relative;
    .label{
      font-size: 13px;
      display: inline-block;
      padding-left: 4px;
    }

    &:hover{
      background-color: @header-light-bg-hover-color;
      .space-sel-panel{
        display: flex;
        transition: height cubic-bezier(.2, 0, 0, 1) .2s;
      }
    }

    &.appAppSpaceSelItem{
      .space-sel-panel{
        top: calc(@sub-header-app - 2px);
      }
    }
    .space-sel-panel{
      border:1px solid #dfdfdf;
      position: absolute;
      top: calc(@header-app - 2px);
      background-color: #FFF;
      transition: display cubic-bezier(.2, 0, 0, 1) .2s;
      box-shadow: 0 4px 6px 0 rgb(12 31 80 / 4%);
      left: 0;
      z-index: 1070;
      cursor: auto;
      padding:0 12px;
      padding-top: 12px;
      padding-right: 0;
      max-width: 300px;
      flex-wrap: wrap;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      white-space: normal;
      font-size: 12px;
      display: none;
      line-height: 1.6;
      font-weight: 400;
      text-align: left;


      .space-item-icon{
        font-size: 24px;
        text-align: center;
        width: 100%;
      }
      .space-item-label{
        width: 100%;
        text-align: center;
      }

      .space-item{
        border:1px solid #dfdfdf;
        flex-wrap: wrap;
        width: 80px;
        padding: 6px 0;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 12px 12px 0;
        cursor:pointer;
        &:hover{
          background-color: @header-light-bg-hover-color;
        }
        &.active{
          background-color: @primary-color;
          color:#FFF;
        }
      }
    }
  }
}
</style>
